import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from './fragments';

export const USER_SAVED = gql`
  subscription userSaved {
    userSaved {
      user {
        ...user
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.user}
  ${CommonFragments.messageHeaders}
`;

export const USER_PASSWORD_RESET = gql`
  subscription userPasswordReset {
    userPasswordReset {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
